import React from 'react';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink/index';
import ThreeDotsDropdownMenu from 'app/general/widgets/ThreeDotsDropdownMenu';
import {StyledDocItem} from 'app/procedures/styles';
import {getProcessName} from 'app/utils/fallbacks';

import type {actionsGetterType} from 'app/general/widgets/ThreeDotsDropdownMenu';
import type {ProcessSerializedType} from 'sweet-types';

type CompactProps = {
  object: ProcessSerializedType;
  actionsGetter: actionsGetterType<ProcessSerializedType>;
};
export const CompactProcessItem = ({object, actionsGetter}: CompactProps) => (
  <StyledDocItem className="row border-bottom py-2">
    <div className="col text-truncate text-nowrap d-flex align-items-center">
      <FullHTMLLink
        html_url={object.html_url}
        className="text-dark font-weight-bold d-block d-sm-inline"
      >
        <i className="far fa-copy" /> {getProcessName(object, true)}
      </FullHTMLLink>
    </div>
    <div className="col-auto pl-0 d-flex align-items-start align-items-sm-center flex-row flex-column-reverse flex-sm-row">
      <ThreeDotsDropdownMenu actionsGetter={actionsGetter} object={object} />
    </div>
  </StyledDocItem>
);
